import moment from "moment";
import { ModalTopSection } from "../../../components/DetailsModal/ModalTopSection";
import {
  DataLoadingView,
  ErrorOccuredView,
  ModalContainer,
  QuickTable,
  QuickTableFilterTabs,
  SectionSubheader,
  SwitchAppButton,
} from "../../../components";
import { ModalSectionTitle } from "../../../components";
import { LeftRightFlexedContainer } from "../../../components";
import { CurrencyDisplay } from "../../../components";
import { Badge } from "../../../components";
import {
  IPaymentLinkDetailsModalViewProps,
  PAYMENTS_BY_PAYLINK_LIST_TABLE_NAME,
} from "./PaymentLinksDetailsModal";
import { StructuredList } from "../../../components";
import { LinkUrlCopyDisplay } from "../LinkUrlCopyDisplay";
import { OverflowMenuDropDown } from "./OverflowMenuDropDown";
import {
  getPaymentLinkStatusIndicator,
  renderBooleanAsText,
} from "../../../utils";
import { appConfig } from "../../../configs";
// import { ModalQuickInfoSection } from "../../../components/DetailsModal/ModalQuickInfoSection";
// import { TopDownFlexedContainer } from "../../../components/DetailsModal/TopDownFlexedContainer";
// import { getCurrencySymbol } from "../../../utils";
// import { NoDataToSeeContainer } from "../../../components";
// import { transactionStatus } from "../../../enums";
// import { object } from "yup";
// import { IViewTransaction } from "../../../interfaces-and-types";
// import { formatAsCurrency } from "../../../utils";
// import { paymentLinkStatus } from "../../../enums";
import imagePlaceholder from "../../../assets/icons/img-placeholder.svg";
import { paymentDisplayFormatter } from "../../Payments/paymentDisplayFormatter";

export const View = (props: IPaymentLinkDetailsModalViewProps) => {
  const statusIndicator = props.modalData
    ? getPaymentLinkStatusIndicator(props.modalData)
    : null;

  return (
    <div className="paymentlink-details-container">
      <ModalContainer
        isModalOpen={props.isModalOpen}
        closeModal={props.closeModal}
        className="payment-modal-container"
        modalHeader={
          !props.modalData ? (
            <SectionSubheader title="PAYMENT LINK DETAILS" />
          ) : (
            <ModalTopSection
              header="PAYMENT LINK DETAILS"
              subHeader={
                <div className="name-sub-header flex-container align-items--end justify-content--start">
                  {props.modalData.line_items[0].product_name}&nbsp;
                  {props.modalData.line_items.length > 1 ? (
                    <>+ {props.modalData.line_items.length - 1} more item(s)</>
                  ) : null}
                </div>
              }
              copyText=""
              copyContent={props.modalData.link_url_with_hostname}
              closeModal={props.closeModal}
            />
          )
        }
      >
        {!props.modalData ? (
          <>
            {props.isLoadingModalData ? (
              <DataLoadingView message={"Loading payment link details"} />
            ) : (
              <ErrorOccuredView
                message={
                  "An error occured while loading the payment link details. Please retry..."
                }
              />
            )}
          </>
        ) : (
          <>
            <div className="flex-container col link-copy-container">
              <div className="flex-container link-copy-main-container row justify-content--between">
                <LinkUrlCopyDisplay
                  link={props.modalData.link_url_with_hostname}
                  wrapperClassName="flex-box"
                />

                <div className="">
                  <OverflowMenuDropDown
                    navigateToEdit={props.navigateToEdit}
                    openDeleteModal={props.openDeleteModal}
                  />
                </div>
              </div>
              <div>Copy and share to start accepting with this link</div>
            </div>

            <div>
              <ModalSectionTitle key_id="Payment Link Details" value="" />

              <LeftRightFlexedContainer
                key_id="Status"
                value={
                  <Badge
                    text={statusIndicator!.statusText}
                    statusColor={statusIndicator!.statusType}
                  />
                }
              />
              <LeftRightFlexedContainer
                key_id="Date Created"
                value={
                  <span className="date--oneline">
                    {moment(props.modalData.created_at).format(
                      appConfig.dateTimeFormat
                    )}
                  </span>
                }
              />
              <LeftRightFlexedContainer
                key_id="Total"
                value={
                  <>
                    <CurrencyDisplay
                      currencyOrSymbol={props.modalData.currency}
                      amount={props.modalData.amount}
                      amountFontSize={14}
                      symbolFontSize={12}
                    />{" "}
                    ({props.modalData.currency})
                  </>
                }
              />
              <LeftRightFlexedContainer
                key_id="Name Required"
                value={
                  <span className="">
                    {renderBooleanAsText(
                      props.modalData.require_customer_full_name
                    )}
                  </span>
                }
              />
              <LeftRightFlexedContainer
                key_id="Address Required"
                value={
                  <span className="">
                    {renderBooleanAsText(
                      props.modalData.require_customer_address
                    )}
                  </span>
                }
              />
              <LeftRightFlexedContainer
                key_id="Phone Required"
                value={
                  <span className="">
                    {renderBooleanAsText(
                      props.modalData.require_customer_phone_number
                    )}
                  </span>
                }
              />
              {/* <LeftRightFlexedContainer
                key_id="xxxxxxxxx"
                value={<span className="">{renderBooleanAsText(xxxxxxxxx)}</span>}
              />
              <LeftRightFlexedContainer
                key_id="xxxxxxxxx"
                value={<span className="">{renderBooleanAsText(xxxxxxxxx)}</span>}
              /> */}
            </div>

            {/* <div className="flex-divider--vertical" /> */}

            <div>
              <ModalSectionTitle key_id="Description" value="" />
              <StructuredList
                isCondensed
                headers={
                  <div className="cds--structured-list-row cds--structured-list-row--header-row">
                    <div className="cds--structured-list-th" />
                    <div className="cds--structured-list-th">PRODUCT NAME</div>
                    <div className="cds--structured-list-th">
                      UNIT PRICE ({props.modalData.currency})
                    </div>
                    <div className="cds--structured-list-th">QTY</div>
                    <div className="cds--structured-list-th">
                      QTY ADJUSTABLE
                    </div>
                  </div>
                }
                {...{
                  rows: props.modalData.line_items.map((item, _) => (
                    <div className="cds--structured-list-tbody">
                      <div className="cds--structured-list-row">
                        <div className="cds--structured-list-td">
                          <img
                            src={item.product_icon || imagePlaceholder}
                            alt="product icon"
                            className="paymentlink-list--product-icon"
                          />
                        </div>
                        <div className="cds--structured-list-td">
                          {item.product_name}
                        </div>
                        <div className="cds--structured-list-td">
                          {item.price}
                        </div>
                        <div className="cds--structured-list-td">
                          {item.qty}
                        </div>
                        <div className="cds--structured-list-td">
                          {item.is_qty_adjustable_by_customer ? "Yes" : "No"}
                        </div>
                      </div>
                    </div>
                  )),
                }}
              />
            </div>

            <div>
              <ModalSectionTitle key_id="Payout Tags" value="" />
              <StructuredList
                isCondensed
                headers={
                  <div className="cds--structured-list-row cds--structured-list-row--header-row">
                    <div className="cds--structured-list-th">TAG NAME</div>
                    <div className="cds--structured-list-th align-text--center">
                      AMOUNT
                    </div>
                    <div className="cds--structured-list-th align-text--center">
                      %
                    </div>
                    <div className="cds--structured-list-th align-text--center">
                      FEE %
                    </div>
                  </div>
                }
                {...{
                  rows: props.modalData.transaction_payout_tags.map(
                    (poTag, _) => (
                      <div className="cds--structured-list-tbody">
                        <div className="cds--structured-list-row">
                          <div className="cds--structured-list-td">
                            {poTag.description ?? "Tag"}: ({poTag.payout_tag})
                          </div>

                          <div className="cds--structured-list-td align-text--center">
                            {!poTag.amount ? (
                              "--"
                            ) : (
                              <CurrencyDisplay
                                amount={poTag.amount}
                                currencyOrSymbol={
                                  props.modalData?.currency ?? "--"
                                }
                                amountFontSize={16}
                                symbolFontSize={12}
                                amountClassName={""}
                                symbolClassName={""}
                              />
                            )}
                          </div>
                          <div className="cds--structured-list-td align-text--center">
                            {poTag.percentage ?? "--"}
                          </div>
                          <div className="cds--structured-list-td align-text--center">
                            {poTag.app_fee_percentage ?? "--"}
                          </div>
                        </div>
                      </div>
                    )
                  ),
                }}
              />
            </div>

            <div>
              <ModalSectionTitle
                key_id="Sales via payment link"
                noBottomBorder
                value=""
              />

              <QuickTable
                id={PAYMENTS_BY_PAYLINK_LIST_TABLE_NAME}
                prefixFiltersWithId
                data={
                  props.transactionsForPaymentLinkContext
                    .transactionsForPaymentLink
                }
                headers={props.transactionsForPaymentLinkContext.headers}
                isLoading={props.transactionsForPaymentLinkContext.isLoading}
                isError={props.transactionsForPaymentLinkContext.isError}
                itemCount={
                  props.transactionsForPaymentLinkContext.meta?.page_meta
                    .item_count || 0
                }
                renderDetail={(item) => item.description}
                toolbarTabs={
                  <QuickTableFilterTabs
                    queryStringTabNavLinks={
                      props.transactionsForPaymentLinkContext.queryStringTabs
                    }
                    filterPrefix={PAYMENTS_BY_PAYLINK_LIST_TABLE_NAME}
                  />
                }
                displayFormatter={paymentDisplayFormatter}
                // openDetailsModal={props.transactionsForPaymentLinkContext.openDetailsModal} // open sales page
                disableClickOnTargetClassNames={["copy-btn"]}
              />
            </div>
          </>
        )}
      </ModalContainer>
    </div>
  );
};
